import styled from 'styled-components';
import { spaceMixin } from '@zillow/constellation';
import { HR } from '@zillow/zrs-comet';

export const StyledHR = styled(HR)`
  && {
    margin: ${spaceMixin('sm')} 0;
  }
`;
